import BaseEnum from "./base_enum.js";

class ProjectProcessEnumDesc extends BaseEnum {

  name() {
    return "project_process";
  }

  rawValues() {
    return ["standard", "small_project"];
  }

}

const ProjectProcessEnum = new ProjectProcessEnumDesc();
export default ProjectProcessEnum;